export default "__VITE_ASSET__GlmC_nm4__"